import { useState } from 'react'
import { useLocation, Link, useNavigate } from 'react-router-dom'
import { ChevronRight, Home, LogOut, User, FileText } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/stores/auth.store'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { useTranslation } from 'react-i18next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { TermsAcceptanceModal } from '@/components/legal/TermsAcceptanceModal'

export const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, logout } = useAuthStore()
  const { t } = useTranslation()
  const [showTerms, setShowTerms] = useState(false)
  
  const pathSegments = location.pathname.split('/').filter(Boolean)
  
  const breadcrumbs = pathSegments.map((segment, index) => {
    const href = '/' + pathSegments.slice(0, index + 1).join('/')
    const translationKey = `breadcrumb.${segment}`
    const name = t(translationKey, segment.charAt(0).toUpperCase() + segment.slice(1))
    
    return {
      href,
      name
    }
  })

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="h-16 border-b bg-card flex items-center justify-between px-6">
      <nav className="flex items-center space-x-2 text-sm">
        <Link 
          to="/dashboard" 
          className="flex items-center text-muted-foreground hover:text-foreground"
        >
          <Home className="w-4 h-4" />
        </Link>
        
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={breadcrumb.href} className="flex items-center space-x-2">
            <ChevronRight className="w-4 h-4 text-muted-foreground" />
            <Link
              to={breadcrumb.href}
              className={`${
                index === breadcrumbs.length - 1
                  ? 'text-foreground font-medium'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {breadcrumb.name}
            </Link>
          </div>
        ))}
      </nav>
      
      <div className="flex items-center space-x-4">
        <LanguageSwitcher />
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="flex items-center space-x-2">
              <User className="w-4 h-4" />
              <span>{user?.email || 'User'}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>{user?.email}</DropdownMenuItem>
            <DropdownMenuItem disabled>
              {user?.is_admin ? 'Admin' : 'User'}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => setShowTerms(true)}>
              <FileText className="w-4 h-4 mr-2" />
              Termini e Condizioni
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} className="text-red-600">
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      {showTerms && (
        <TermsAcceptanceModal readOnly onClose={() => setShowTerms(false)} />
      )}
    </header>
  )
}
